<template>
<div>
    <div class="d-flex justify-center">
        <v-card width="400px" class="transparent mt-10" flat v-if="$vuetify.breakpoint.mdAndUp" 
            style="border-top-right-radius:0; border-bottom-right-radius:0">
            <v-img 
                :src="require('@/assets/login.png')"
                height="100%">
                </v-img>
        </v-card>
        <v-card :width="tam" class="white pb-4" :class="[{'mt-0': $vuetify.breakpoint.xsOnly}, {'mt-10': $vuetify.breakpoint.smAndUp}]"
            style="border-top-left-radius:0; border-bottom-left-radius:0">
            <div class="px-8 pt-8 pb-5 accent">
                <div class="d-flex justify-center">
                    <div>
                        <v-img 
                            :src="require('@/assets/new-logo.png')"
                            width="130px">
                            </v-img>
                    </div>
                </div>
                <!-- <div class="d-flex justify-center">
                    <div class="white--text mt-4 subtitle-2 font-weight-bold text-center" style="border-top: 1px solid white; width:180px; padding-top:6px">
                        3 STEPS ONLINE WORLD
                    </div>
                </div> -->
            </div>

            <v-card-text class="pt-6 pb-2" :class="[{'px-6': $vuetify.breakpoint.smAndDow}, {'px-10': $vuetify.breakpoint.mdAndUp}]">
                <v-text-field
                    v-model="model.email"
                    label="Email"
                    outlined dense
                    @keydown.enter="validate"
                    type="email"
                    class="mt-4">
                    <template v-slot:prepend>
                        <v-icon color="info" class="mt-1 mr-1" small>fa-envelope</v-icon>
                    </template>
                </v-text-field>
                
                <v-text-field
                    class="mt-1"
                    v-model="model.pwd"
                    label="Password"
                    outlined dense
                    @keydown.enter="validate"
                    type="password">
                    <template v-slot:prepend>
                        <v-icon color="info" class="mt-1 mr-1" small>fa-lock</v-icon>
                    </template>
                </v-text-field>

                <div class="d-flex justify-end mt-n4">
                        <v-btn depressed small rounded @click="$router.push('/lostpassword')" class="grey--text text--darken-1 mt-3">
                            <v-icon size="10px" color="grey" left>fa-key</v-icon>
                            <span class="font-weight-regular" style="font-size:9px">Forgot my password</span>
                        </v-btn>
                    </div>

                <template v-if="!sending">
                    <div class="d-flex justify-center mt-10">
                        <v-btn x-large depressed class="accent white--text" @click="validate">
                            Login
                        </v-btn>
                    </div>
                </template>

                <div class="mb-5 pt-12 pb-4 d-flex justify-center" v-if="sending">
                    <v-progress-circular :size="40" :width="3" color="accent" indeterminate></v-progress-circular>
                </div>

                <div class="mt-10">
                    <v-divider></v-divider>
                </div>

                <!-- <div class="d-flex justify-center mt-3">
                    <v-btn text class="accent--text" @click="$router.push('/signup')">
                        Sign up 
                        <v-icon small color="accent" right>fa-angle-right</v-icon>
                    </v-btn>
                </div>

                <div class="mt-2">
                    <v-divider></v-divider>
                </div> -->

                <div class="caption mt-6 mb-2 text-xs-center d-flex justify-center">
                    <div>
                        <a href="/terms-and-conditions" style="font-size:11px">
                            Terms and conditions
                        </a>
                        
                    </div>
                    <div class="ml-3">
                        <a href="https://3stepstocollege.com/privacy-policy" target="_blank" style="font-size:11px">
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</div>
</template>

<script>
import FireErrors from '@/services/fireErrors'
import Sign from '@/firebase/sign'

export default {
    data() {
        return {
            sent: false,
            sending: false,
            model: {
                email: '',
                pwd: ''
            }
        }
    },
    computed: {
        tam() {
            if (this.$vuetify.breakpoint.xsOnly) {
                return '100%';
            } else {
                return '400px';
            }
        }
    },
    watch: {
        user(value) {
            if (value != null && this.sent) {
                this.sending = false;
                window.scrollTo(0, 0);
            }
        }
    },
    methods: {
        validate() {
    		if (!this.validateIsEmpty(this.model.email) && !this.validateIsEmpty(this.model.pwd)) {
    			this.signIn();
            } else {
                window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'Email and password is required.'});
            }
    	},
    	signIn() {
            this.sending = true;
            this.sent = true;
            Sign.signin(this.model)
    				.then(response => {
    					if (response !== true) {
                            this.sending = false;
                            window.scrollTo(0, 0);
    						this.$store.dispatch('setSnack', {kind:'error', text:FireErrors.get(response)});
    					}
    				});
        }
    }
}
</script>



